<small [attr.id]="id" class="form-text" aria-live="polite">
  {{ 'form_char_count_text' | translate: [getLength(field), charLimit] }}
</small>
